/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from "react";

interface IFilterFormValuesContextProviderProps {
  values: any;
  setValues: (values: any) => void;
  children: React.ReactNode;
}

export const FilterFormValuesContext = React.createContext({
  values: {},
  setValues: (_values: any) => {},
});

export const useFilterFormValuesContext = () =>
  React.useContext(FilterFormValuesContext);

export const FilterFormValuesContextProvider = (
  props: IFilterFormValuesContextProviderProps
) => (
  <FilterFormValuesContext.Provider
    value={{ values: props.values, setValues: props.setValues }}
  >
    {props.children}
  </FilterFormValuesContext.Provider>
);
